import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeAddReclamationDialog } from 'store/common/commonActions';
import { fetchPieceGestionLignes, fetchCommandeGestionLignes } from 'store/pieceGestionLigne/pieceGestionLigneActions';

import DemandeRetourMarchandiseLivreeConformeStep from './DemandeRetourMarchandiseLivreeConformeStep';

import { controlerEligibiliteRetourVolontaire, controlerArticlesPLVRetourVolontaire } from 'utils/posters';

import dateHelper from 'utils/dateHelper';
import localStorageHelper from 'utils/localStorageHelper';

import { CodesDepotPlateforme } from 'constants.js';

class DemandeRetourMarchandiseLivreeConformeStepContainer extends React.Component {
    

    handleClickCheckEligibilite = async () => {
        const { reclamation } = this.props;

        const lignes = reclamation.lignes.map(ligne => { return { numero: ligne.numeroLigne, quantite: ligne.quantiteAnomalie }; })

        var result = await this.props.controlerEligibiliteRetourVolontaire(reclamation.pieceCle || reclamation.numeroPiece, lignes, reclamation.typePiece);

        if (result.error) {
            return null;
        }
        // L'état du composant sera mis à jour en fonction du résultat 

        return result;

    }

    handleClickCheckArticlesPLV = async (codeDepot) => {

        const { reclamation } = this.props;

        console.log("reclamation.lignes", reclamation.lignes);

        const lignes = reclamation.lignes.map(ligne => { return { numero: ligne.numeroLigne, quantite: ligne.quantiteAnomalie, erreurKit: ligne.erreurKit }; })

        var result = await this.props.controlerArticlesPLVRetourVolontaire(reclamation.pieceCle || reclamation.numeroPiece, lignes, codeDepot, reclamation.typePiece);

        if (result.error) {
            return null;
        }
        // L'état du composant sera mis à jour en fonction du résultat 

        return result;
    }

    render() {

        const props = {
            ...this.props,
            onClickCheckEligibilite: this.handleClickCheckEligibilite,
            onClickCheckArticlesPLV: this.handleClickCheckArticlesPLV,
        }

        return (
            <DemandeRetourMarchandiseLivreeConformeStep {...props} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    const utilisateurMagasin = localStorageHelper.getUtilisateurMagasin();
    const isAdmin = localStorageHelper.isAdmin();
    const utilisateurATC = localStorageHelper.getUtilisateurATC();
    const utilisateurManagerCommercial = localStorageHelper.getUtilisateurManagerCommercial();

    const masquerModeRetourClientMagasin =
        !isAdmin
        && !utilisateurMagasin
        && (utilisateurATC || utilisateurManagerCommercial);

    //let fraisRetourExclusion = false;
    let loadingLignes = false;
    let auMoinsUnRetourExclu = false;
    let aucunRetourPossible = true;
    let dateLivraison = null;
    let adresse = null;

    let piece = state.pieceGestion[ownProps.namespace].piecesGestion ? state.pieceGestion[ownProps.namespace].piecesGestion.items.find(p => p.numeroPiece === ownProps.reclamation.numeroPiece) : null;

    let poidsTheorique = '';
    let transporteurInitial = null;

    let departPlateforme = false;

    // RECLA-771 le contact pour un enlèvement, on reprend tout depuis contact si non renseigné, on prend les infos au client
    let donneurOrdre = {
        nom: ownProps.reclamation.suiviNomContact,
        mail: ownProps.reclamation.suiviEmail !== null && ownProps.reclamation.suiviEmail !== '' ? ownProps.reclamation.suiviEmail : ownProps.reclamation.client.email,
        telephoneMobile: ownProps.reclamation.suiviTelephoneMobile !== null && ownProps.reclamation.suiviTelephoneMobile !== '' ? ownProps.reclamation.suiviTelephoneMobile : ownProps.reclamation.client.telephoneMobile
    };

    let agePiece = -1;

    if (piece) {
        adresse = piece.adresseLivraison;
        dateLivraison = piece.dateLivraison;

        poidsTheorique = ownProps.reclamation.lignes.reduce((accumulator, currentValue) => accumulator + currentValue.poids * currentValue.quantiteAnomalie, 0);

        transporteurInitial = {
            nom: piece.transporteur,
            contrat: piece.contrat
        };

        agePiece = dateHelper.age(piece.dateLivraison);

        let lignes = state.pieceGestionLigne.pieceGestionLignes.items;
        loadingLignes = state.pieceGestionLigne.pieceGestionLignes.isLoading;


        auMoinsUnRetourExclu = lignes.reduce((accumulator, currentValue) => {
            return (accumulator || currentValue.retourExclusionFlag > 0);
        }, false);

        aucunRetourPossible = lignes.reduce((accumulator, currentValue) => {
            return (accumulator && currentValue.retourExclusionFlag > 0);
        }, true);

        departPlateforme = CodesDepotPlateforme.indexOf(piece.codeDepot) !== -1;

    }

    return {
        dateLivraison: dateLivraison,
        adresse: adresse,
        donneurOrdre: donneurOrdre,
        poidsTheorique: poidsTheorique,
        masquerModeRetourClientMagasin: masquerModeRetourClientMagasin,
        transporteurInitial: transporteurInitial,
        agePiece: agePiece,
        loadingLignes: loadingLignes,
        auMoinsUnRetourExclu: auMoinsUnRetourExclu,
        aucunRetourPossible: aucunRetourPossible,
        departPlateforme: departPlateforme,
        // DEV-4012 : profil magasin → l'option « Retour depuis la commande » est grisée.
        utilisateurMagasin: utilisateurMagasin
    };
};

const mapDispatchToProps = (dispatch) => ({
    closeAddReclamationDialog: () => dispatch(closeAddReclamationDialog()),
    controlerEligibiliteRetourVolontaire: (numeroPiece, lignes, typePiece) => dispatch(controlerEligibiliteRetourVolontaire(numeroPiece, lignes, typePiece)),
    controlerArticlesPLVRetourVolontaire: (numeroPiece, lignes, codeDepot, typePiece) => dispatch(controlerArticlesPLVRetourVolontaire(numeroPiece, lignes, codeDepot, typePiece)),
    // DEV-4012 : chargement des lignes après le choix du type de retour (alimente le store partagé pieceGestionLigne).
    fetchPieceGestionLignes: (numeroPiece, defautProduitInfos, logistiqueInfos, savInfos, codeDepot) =>
        dispatch(fetchPieceGestionLignes(numeroPiece, defautProduitInfos, logistiqueInfos, savInfos, codeDepot)),
    fetchCommandeGestionLignes: (cle, codeDepot) => dispatch(fetchCommandeGestionLignes(cle, codeDepot)),
});

DemandeRetourMarchandiseLivreeConformeStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired,

    onClose: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DemandeRetourMarchandiseLivreeConformeStepContainer);
